export class FetchTeamsAction {
  static readonly type = '[Team] Fetch Teams';

  constructor() {
  }
}
